import { render, staticRenderFns } from "./ActivityGroupMenu.vue?vue&type=template&id=208c2c98&scoped=true"
import script from "./ActivityGroupMenu.vue?vue&type=script&lang=js"
export * from "./ActivityGroupMenu.vue?vue&type=script&lang=js"
import style0 from "./ActivityGroupMenu.vue?vue&type=style&index=0&id=208c2c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c2c98",
  null
  
)

export default component.exports